import { format } from 'date-fns';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { PublicationStatusBadge } from './PublicationStatusBadge';
import type { Publication } from '../types';

interface Props {
  publications: Publication[];
  onRowClick?: (p: Publication) => void;
}

export function PublicationTableView({ publications, onRowClick }: Props) {
  return (
    <div className="border rounded-lg overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-32">Publish date</TableHead>
            <TableHead>Title (EN)</TableHead>
            <TableHead className="w-32">Status</TableHead>
            <TableHead className="w-48">Channels</TableHead>
            <TableHead className="w-32">Intentions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {publications.length === 0 && (
            <TableRow>
              <TableCell colSpan={5} className="text-center text-muted-foreground py-8">
                No publications
              </TableCell>
            </TableRow>
          )}
          {publications.map((p) => (
            <TableRow
              key={p.id}
              className={onRowClick ? 'cursor-pointer' : undefined}
              onClick={() => onRowClick?.(p)}
            >
              <TableCell className="text-xs text-muted-foreground whitespace-nowrap">
                {p.publishDate ? format(new Date(p.publishDate), 'yyyy-MM-dd') : '—'}
              </TableCell>
              <TableCell className="max-w-xl truncate">{p.titleEn ?? p.titleFr ?? '—'}</TableCell>
              <TableCell><PublicationStatusBadge status={p.status} /></TableCell>
              <TableCell className="text-xs">
                {p.channels.length > 0 ? p.channels.join(', ') : '—'}
              </TableCell>
              <TableCell className="text-xs text-muted-foreground">{p.intentions ?? '—'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
